import React from 'react';
import {
  Button,
  Stack,
  Switch,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AddIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { Legend } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  TableHeader,
  Table,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import DocumentTitle from 'react-document-title';
import { injectIntl } from 'react-intl';
import ElementWithPermissions from '../../../components/ElementWithPermissions';
import messages from '../messages';
import { useManageProspects } from './hooks';
import withReduxStore from './withReduxStore';
import useBaseTableProps from '../../../hooks/useBaseTableProps';
import TableLayout from '../../../components/TableLayout';

const ManageProspects = ({ intl, store }) => {
  const baseTableProps = useBaseTableProps();
  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    name,
    order,
    orderBy,
    rows,
    searchState,
    selectedColumns,
    isLoading,
    totalCount,
    onCSVButtonClick,
    onNewProspectClick,
    showAllStatuses,
    setShowAllStatuses,
  } = useManageProspects({ intl, store });

  return (
    <DocumentTitle title={intl.formatMessage(messages.title)}>
      <TableLayout name={name} childrenElementsHeight={50 + 8 + 60}>
        {(tableHeight) => (
          <>
            <TableHeader
              title={intl.formatMessage(messages.header)}
              count={count}
              totalCount={totalCount}
              sx={{ padding: 0, mb: 1 }}
              actions={
                <ElementWithPermissions scope={['prospect-create']}>
                  <Button
                    variant="shout"
                    onClick={onNewProspectClick}
                    startIcon={<AddIcon />}
                  >
                    {intl.formatMessage(messages.newProspect)}
                  </Button>
                </ElementWithPermissions>
              }
            />
            <Stack spacing={2} sx={{ maxWidth: 'fit-content' }}>
              <Legend
                data={[
                  {
                    label: intl.formatMessage(messages.yellowLegend),
                    sx: { backgroundColor: 'warning.lighter' },
                  },
                ]}
              />
              <Switch
                checked={showAllStatuses}
                onChange={() => setShowAllStatuses(!showAllStatuses)}
                label={intl.formatMessage(messages.showAllStatusesLabel)}
              />
            </Stack>

            <Table
              {...baseTableProps}
              allColumnsHidden={allColumnsHidden}
              columnOptions={columnOptions}
              dateState={dateState}
              filterState={filterState}
              filterTypeState={filterTypeState}
              handleColumnChange={handleColumnChange}
              handleDateSubmit={handleDateSubmit}
              handleFilterChange={handleFilterChange}
              handleFilterTypeChange={handleFilterTypeChange}
              handleSearchSubmit={handleSearchSubmit}
              handleSortChange={handleSortChange}
              headers={filteredHeaders}
              height={tableHeight}
              isLoading={isLoading}
              name={name}
              order={order}
              orderBy={orderBy}
              rows={rows}
              count={count}
              searchState={searchState}
              selectedColumns={selectedColumns}
              totalCount={totalCount}
              onCSVButtonClick={onCSVButtonClick}
            />
          </>
        )}
      </TableLayout>
    </DocumentTitle>
  );
};

export default injectIntl(withReduxStore(ManageProspects));
